export default "__VITE_ASSET__CVtvs8qW__"